import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { useTranslation } from "react-i18next";
import { useHeaders } from "./tableHeaders";

import { useEffect } from "react";

export const getID = (v: any) => v.uuid;

export default ({ items, tableRef, isOpen, onOpenInventory, onChangeAny, totalCount, handleScroll }: any) => {
	const { t } = useTranslation();
	const { headers } = useHeaders(onOpenInventory);

	return (
		<SBBox
			id="distribution-view-container"
			width={isOpen ? "50vw" : "100%"}
			style={{
				transition: "all 0.25s ease",
				marginTop: "1rem",
			}}
		>
			<SBNewTable
				virtualize
				hasSelection
				collapseFieldName={"plans"}
				title={t("suggestedDistribution") as string}
				defaultColumns={headers}
				ref={tableRef}
				startRows={items}
				onClick={(cell: any) => {
					if (cell.row.getCanExpand()) {
						cell.row.toggleExpanded();
					}
				}}
				onDataUpdated={onChangeAny}
				totalCount={totalCount}
				onScroll={handleScroll}
			/>
		</SBBox>
	);
};
